export enum CustomerSourceEnum {
  WALK_IN = 'WALK_IN',
  INBOUND_CALL = 'INBOUND_CALL',
  OUTBOUND_CALL = 'OUTBOUND_CALL',
}
